import classNames from 'classnames';
import type { FC } from 'react';
import { useState } from 'react';
import React from 'react';

import Button from '../ui/Button';
import Checkbox from '../ui/Checkbox';
import Icon from '../ui/Icon';

interface IReviewFooterProps {
  onSubmit: () => void;
  submitText: string;
  confirmText?: string;
  hint?: string;
}

const DEFAULT_HINT = 'Bitte überprüfen Sie alle Angaben sorgfältig. '
  + 'Nach der Beauftragung können Änderungen zu Verzögerungen und zusätzlichen Kosten führen.';

const DEFAULT_CONFIRM = 'Ich habe alle Angaben überprüft und bestätige, dass sie korrekt sind.';

const ReviewFooter: FC<IReviewFooterProps> = ({
  onSubmit,
  submitText,
  confirmText = DEFAULT_CONFIRM,
  hint = DEFAULT_HINT
}) => {
  const [ confirmed, setConfirmed ] = useState(false);
  const [ showError, setShowError ] = useState(false);

  const handleSubmit = (): void => {
    if (confirmed) {
      onSubmit();
    } else {
      setShowError(true);
    }
  };

  const handleConfirmChange = (checked: boolean): void => {
    setConfirmed(checked);

    if (checked) {
      setShowError(false);
    }
  };

  return (
    <div className="review-footer">
      <div className="review-note">
        <span className="review-note-icon">
          <Icon icon="info" />
        </span>
        <p>{hint}</p>
      </div>
      <Checkbox
        name="reviewConfirmed"
        checked={confirmed}
        onChange={handleConfirmChange}
        hasError={showError}
      >
        {confirmText}
      </Checkbox>
      <div className="review-submit">
        {showError && (
          <div className="error-box review-error" role="alert">
            Bitte bestätigen Sie zuerst, dass Sie alle Angaben überprüft haben,
            um den Auftrag verbindlich abzuschicken.
          </div>
        )}
        <Button
          className={classNames('btn-xl', {
            'btn-disabled': !confirmed
          })}
          onClick={handleSubmit}
          hasRightIcon
          icon="arrow-right"
        >
          {submitText}
        </Button>
      </div>
    </div>
  );
};

export default ReviewFooter;
